import {
  TEMPLATE_START,
  TEMPLATE_SUCCESS,
  TEMPLATE_ERROR,
} from './TemplateOverviewTypes';

const INITIAL_STATE = {
  loading: false,
  error: false,
  data: [],
};

export default (state: any = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case TEMPLATE_START:
      return { ...state, loading: true, error: null };

    case TEMPLATE_SUCCESS:
      return { ...state, data: action.payload, loading: false };

    case TEMPLATE_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
